"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var comment_1 = __importDefault(require("./sub/comment"));
var link_1 = __importDefault(require("./sub/link"));
var logo_1 = __importDefault(require("./sub/logo"));
var main_media_1 = __importDefault(require("./sub/main-media"));
var description_1 = __importDefault(require("./sub/description"));
var title_1 = __importDefault(require("./sub/title"));
var ctaButton_1 = __importDefault(require("./sub/ctaButton"));
var transparencyButton_1 = __importDefault(require("./sub/transparencyButton"));
var Business = function (_a) {
    var adObj = _a.adObj, troika = _a.troika, grid = _a.grid;
    if (troika) {
        return React.createElement(TroikaBusiness, { adObj: adObj, grid: grid });
    }
    return React.createElement(SpadenBusiness, { adObj: adObj });
};
var SpadenBusiness = function (_a) {
    var adObj = _a.adObj, native = _a.adObj.native;
    return (React.createElement("div", null,
        React.createElement(comment_1.default, { placement: "Business", adObj: adObj }),
        React.createElement("div", { className: "ssa-content-ad" },
            React.createElement(transparencyButton_1.default, { adObj: adObj, className: "ads-transparency-general ads-transparency-ssa-content", style: { height: '10px' } }),
            React.createElement(link_1.default, { adObj: adObj, className: "linkblock link--block dark-links" },
                React.createElement("div", { className: "ssa-flex ssa-flex--column", style: { height: '100%', clear: 'both' } },
                    React.createElement("div", { className: "ssa-flex ssa-content-ad__annonse", style: { flex: 1 } }, "ANNONSE"),
                    React.createElement("div", { className: "ssa-flex ssa-flex--justify-space-between align-items-center ssa-content-ad__titlegroup" },
                        React.createElement(title_1.default, { h: 3, native: native, className: "man u-ma0 licorice u-licorice ssa-content-ad__heading" }),
                        React.createElement(logo_1.default, { native: native, width: 70, height: 70, className: "blockify u-blockify ssa-content-ad__logo" })),
                    React.createElement("div", { className: "flex ssa-content-ad__body" },
                        React.createElement("div", { className: "ssa-content-ad__image_container", style: { flex: 'none' } },
                            React.createElement(main_media_1.default, { native: native, width: 330, height: 330, className: 'blockify u-blockify ssa-content-ad__image' })),
                        React.createElement("div", { className: "ssa-flex ssa-flex--column ssa-flex--justify-space-between ssa-content-ad__box" },
                            React.createElement(description_1.default, { native: native, className: "man u-ma0 licorice u-licorice ssa-content-ad__description" }),
                            React.createElement("p", { className: "man u-ma0" },
                                React.createElement(ctaButton_1.default, { native: native, className: "primary button button--cta ssa-content-ad__cta" })))))))));
};
var TroikaBusiness = function (_a) {
    var adObj = _a.adObj, native = _a.adObj.native, grid = _a.grid;
    return (React.createElement(React.Fragment, null,
        React.createElement(comment_1.default, { placement: "Business", adObj: adObj }),
        React.createElement("div", { "aria-owns": "result-item-heading-" + adObj.targetId }),
        React.createElement("div", { className: "ads__unit__img" },
            React.createElement("div", { className: "ads__unit__img__ratio img-format img-format--ratio3by2 img-format--centered" },
                React.createElement(main_media_1.default, { native: native, className: "img-format__img" }))),
        React.createElement("div", { className: "ads__unit__content" },
            React.createElement("h2", { className: "ads__unit__content__title", id: "result-item-heading-" + adObj.targetId },
                React.createElement(link_1.default, { adObj: adObj, className: "ads__unit__link" },
                    React.createElement(title_1.default, { native: native }))),
            React.createElement("div", { className: "ads__unit__content__status" },
                React.createElement("span", { className: "status status--warning u-mb8" }, "Annonse")),
            React.createElement(description_1.default, { native: native, className: "ads__unit__content__list truncate u-pb8" }),
            React.createElement("div", { className: "ads__unit__content__keys" },
                React.createElement(logo_1.default, { native: native, style: { maxHeight: '40px', maxWidth: '75px' } }),
                React.createElement(ctaButton_1.default, { native: native, className: "button button--cta button--small" }))),
        React.createElement("div", { className: "ads__unit__tools" },
            React.createElement("div", { className: "button button--has-icon button--pill icon" },
                React.createElement(transparencyButton_1.default, { adObj: adObj, style: {
                        position: 'relative',
                        right: '31px',
                        bottom: '15px',
                        filter: grid ? 'brightness(0) invert(1)' : 'invert(1)',
                        transform: 'scaleY(1.2) scaleX(1.2)',
                    } })))));
};
exports.default = Business;
